import BookmarkLineSvg from "@/src/assets/icons/icon-bookmark-line.svg";
import BookmarkSvg from "@/src/assets/icons/icon-bookmark.svg";
import { styled } from "styled-components";
import Icon from "../../atom/Icon";

interface BookMarkStatusProps {
  bookMarkStatus?: boolean;
  onClickBookMark: () => void;
  isEditAuth?: boolean;
}

function BookMarkStatus({
  bookMarkStatus,
  onClickBookMark,
  isEditAuth = true,
}: BookMarkStatusProps) {
  return (
    <BookMarkStatusContainer>
      <BookMark
        data-disabled={!isEditAuth}
        onClick={() => isEditAuth && onClickBookMark()}
      >
        {bookMarkStatus === true ? (
          <Icon iconSrc={BookmarkSvg} iconSize={20} />
        ) : (
          <Icon iconSrc={BookmarkLineSvg} iconSize={20} />
        )}
      </BookMark>
    </BookMarkStatusContainer>
  );
}

export default BookMarkStatus;

const BookMarkStatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 0px 0px 0.5px rgba(160, 164, 171, 0.20), 0px 1px 2px 0px rgba(5, 29, 57, 0.10);
  height: 32px;
  width: 32px;
`;

const BookMark = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px;

  &[data-disabled="true"] {
    cursor: not-allowed;
  }
`;
